module.exports = __webpack_public_path__ + "img/myself04.061a7197.png";